import { render, staticRenderFns } from "./dialog-shortcut.vue?vue&type=template&id=8cb40ba8&"
import script from "./dialog-shortcut.vue?vue&type=script&lang=js&"
export * from "./dialog-shortcut.vue?vue&type=script&lang=js&"
import style0 from "./dialog-shortcut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports